app = angular.module('harriApp');
/**
 * This file contain all media API handler.
 */
app.factory('userMedia', ['httpHelper', '$q', 'asyncGlobalHandler', function (httpHelper, $q, asyncGlobalHandler) {
    var userMedia = {};

    userMedia.mediaCache = null;

    /**
     * get user basic media
     * its mapped to this API: http://doc.harri.com/views/rest-api/user_media.html#get--api-v1-user-basic_media
     * {
      "user_background": {
          "path": "/user/media",
          "uuid": "7812738123"
      },
      "user_profile": {
          "path": "users/1/user_profile/",
          "uuid": "ec7f97e42f32432e805f1bb5c702d54b"
      }
       }
     * @returns {Deferred}
     */
    userMedia.getUserBasicMedia = function () {
        var deferred = $q.defer(), result = httpHelper.g('user/basic_media');

        if (!userMedia.mediaCache) {
            result.then(function (data) {
                userMedia.mediaCache = data.data.data;
                deferred.resolve(data.data.data);
            }, function (err) {
                deferred.reject(err);
            });
        }
        else{
            deferred.resolve( userMedia.mediaCache );
        }

        asyncGlobalHandler.watchPromise(result);

        return deferred.promise;
    };


    /**
     * Clear cached user media.
     */
    userMedia.clearCache = function(){
        userMedia.mediaCache = null;
    };

    return userMedia;

}]);